/* OatBiotics produktrekommendation
   Convertor 2026-09-22
   Ladda upp som temafil under Assets i Shopify.
   ALLA INSTÄLLNINGAR ligger i OB_CONFIG längst upp i filen. */

(function(){
  "use strict";

  /* =====================================================================
     INSTÄLLNINGAR
     ===================================================================== */
  var OB_CONFIG = {
    // Produkternas handle, alltså sista delen av produktens webbadress:
    // referm.se/products/DET-HAR-AR-HANDLE
    // Koden slår själv upp rätt variant-ID via Shopify, så du behöver
    // inte leta reda på några siffror.
    //
    // Har en produkt flera varianter och du vill peka ut en bestämd,
    // fyll i variantId också. Lämnas det tomt väljs första köpbara varianten.
    produkter: {
      gutbarrier: { handle:"gut-barrier-kapslar",            variantId:"" },
      stress:     { handle:"stress-kapslar",                 variantId:"" },
      menopause:  { handle:"menopause-kapslar",              variantId:"" },
      storpase:   { handle:"oatbiotics-gut-barrier-240g",    variantId:"" }
    },
    // Storpåsen är slut i lager. false döljer både pulverväxeln och
    // tillvalet på resultatsidan. Sätt till true när den finns igen.
    storpaseIlager: false,
    // Rabattkoder. Sätt samma sträng på båda om ni bara vill ha en.
    koder: { ny:"PROVA", tillbaka:"TILLBAKA" },
    // Sätt till false om ni inte vill skicka event till dataLayer.
    ga4: true,
    // Sparar e-post och quizsvar som cart attributes så de följer med ordern.
    sparaCartAttributes: true,
    // MÅSTE vara false på sajten. true visar en panel med testscenarier
    // som bara är till för intern genomgång.
    visaTestscenarier: false,

    // KLAVIYO
    // publicKey  = Klaviyos publika API-nyckel, sex tecken. Finns under
    //              Settings > Account > API keys i Klaviyo. Den är publik
    //              och avsedd att ligga i webbläsaren, till skillnad från
    //              den privata nyckeln som aldrig får läggas här.
    // listId     = ID för listan prenumeranterna ska hamna i. Syns i
    //              webbadressen när du öppnar listan i Klaviyo.
    // Lämnas de tomma hoppas Klaviyo-anropet över helt.
    klaviyo: {
      publicKey: "VCMZEV",
      listId: "RBNFCZ",
      revision: "2024-10-15"
    }
  };

  /* =====================================================================
     PRODUKTER
     ===================================================================== */
  var P = {
    gutbarrier:{key:"gutbarrier",namn:"OatBiotics® Gut Barrier",pack:"60 kapslar",pris:399,
      dos:"1 till 2 kapslar om dagen",referm:"700 mg",rack:"30 till 60 dagar",dag:"från 6,65 kr per dag",
      what:"100% postbiotika från fermenterad svensk havre. 700 mg ReFerm® per kapsel, inget annat."},
    stress:{key:"stress",namn:"OatBiotics® Stress",pack:"30 kapslar",pris:345,
      dos:"1 kapsel på fastande mage per dag",referm:"550 mg",rack:"30 dagar",dag:"11,50 kr per dag",
      what:"550 mg ReFerm® per kapsel, plus zink, pantotensyra, B6 och B12. B6 och B12 bidrar till normal psykologisk funktion och till att minska trötthet och utmattning, pantotensyra till normal mental prestationsförmåga. Innehåller även Bacopa monnieri."},
    menopause:{key:"menopause",namn:"OatBiotics® Menopause",pack:"30 kapslar",pris:345,
      dos:"1 kapsel på fastande mage per dag",referm:"600 mg",rack:"30 dagar",dag:"11,50 kr per dag",
      what:"600 mg ReFerm® per kapsel, plus B6 och B12. B6 bidrar till att reglera hormonaktiviteten och till att minska trötthet och utmattning, och båda bidrar till normal psykologisk funktion. Innehåller även rödklöverextrakt."},
    storpase:{key:"storpase",namn:"OatBiotics® Gut Barrier storpåse",pack:"240 g pulver",pris:475,
      dos:"börja med 1 msk om dagen",referm:"pulver",rack:"så länge du vill att den ska räcka",dag:"",
      what:"Samma fermenterade havre, ReFerm®, som i kapslarna, i lös form. Strö över gröt eller yoghurt, eller blanda i en smoothie. Passar hela familjen."}
  };

  /* =====================================================================
     FRÅGOR
     ===================================================================== */
  var SYMTOM=[
    {v:"uppsvalld",   t:"Uppsvälld mage",                kort:"uppsvälld mage",n:3861},
    {v:"gaser",       t:"Gaser",                         kort:"gaser",n:3819},
    {v:"smarta",      t:"Smärta eller magknip",          kort:"smärta",n:2703},
    {v:"bade",        t:"Både lös och hård mage",        kort:"en mage som pendlar",n:2316},
    {v:"diarre",      t:"Diarré eller lös mage",         kort:"lös mage",n:1931},
    {v:"illamaende",  t:"Illamående",                    kort:"illamående",n:1433},
    {v:"forstoppning",t:"Förstoppning eller hård mage",  kort:"förstoppning",n:1430},
    {v:"ingabesvar",  t:"Inga av dessa, jag vill förebygga",kort:"",n:-1}
  ];

  // Vikter: m = Menopause, s = Stress
  var KRING=[
    {v:"vallningar",t:"Värmevallningar eller svettningar på natten",m:4,s:0,sig:"värmevallningar"},
    {v:"mens",      t:"Mensen har blivit oregelbunden eller upphört",m:4,s:0,sig:"att mensen förändrats"},
    {v:"torrhet",   t:"Torrare hud och slemhinnor",m:2,s:0,sig:"torrare hud"},
    {v:"hjarndimma",t:"Hjärndimma",m:2,s:2,sig:"hjärndimma"},
    {v:"klimakterie",t:"Andra för-/klimakterierelaterade besvär",m:4,s:0,sig:"besvär du själv kopplar till klimakteriet"},
    {v:"varvaner",  t:"Svårt att varva ner, tankarna snurrar på kvällen",m:0,s:4,sig:"att du har svårt att varva ner"},
    {v:"spand",     t:"Spänd käke, axlar eller återkommande huvudvärk",m:0,s:3,sig:"spänningar i kropp och käke"},
    {v:"irriterad", t:"Jag blir lätt irriterad eller överväldigad",m:1,s:2,sig:"kortare stubin än vanligt"},
    {v:"somn",      t:"Sömnen har blivit sämre",m:1,s:1,sig:"sämre sömn"},
    {v:"inget",     t:"Nej, det är magen som är problemet",m:0,s:0,sig:""}
  ];

  var Q={
    q1:{kicker:"Först, det viktigaste",title:"Vilka besvär upplever du?",
      help:"Kryssa i allt som stämmer.",chips:true,items:SYMTOM,none:"ingabesvar"},
    kon:{kicker:"Fråga 2",title:"Är du kvinna eller man?",
      help:"Vi frågar för att inte föreslå fel produkt.",
      opts:[{v:"kvinna",t:"Kvinna"},{v:"man",t:"Man"},{v:"ejsvar",t:"Vill inte ange"}]},
    q2:{kicker:"Fråga 3",title:"Vad passar in på dig?",
      opts:[
        {v:"svara",t:"Svåra besvär",tail:"Magen styr vad jag äter, var jag är och ibland om jag går ut alls"},
        {v:"mattliga",t:"Måttliga besvär",tail:"Det är jobbigt och återkommande, men jag lever med det"},
        {v:"inga",t:"Inga direkta besvär",tail:"Jag vill ta hand om min mage innan något krånglar"}
      ]},
    q3:{kicker:"Fråga 4",title:"Förutom magen, vad upplever du?",
      help:"Kryssa i allt som stämmer, eller hoppa över om inget gör det.",
      chips:true,items:KRING,none:"inget"},
    q4:{kicker:"Sista frågan",title:"Har du tagit våra produkter tidigare?",
      opts:[
        {v:"ny",t:"Nej, aldrig"},
        {v:"en",t:"Ja, jag tar det nu, en kapsel om dagen"},
        {v:"tva",t:"Ja, jag tar det nu, två kapslar om dagen"},
        {v:"paus",t:"Ja, men jag har gjort uppehåll"}
      ]}
  };

  /* =====================================================================
     LOGIK
     ===================================================================== */
  function resolve(a){
    var r={produkt:null,grad:null,komplement:null,diagnos:false,m:0,s:0,signals:[],kon:a.kon||null};

    var s1=a.q1||[];
    r.diagnos = s1.some(function(v){
      return SYMTOM.some(function(x){return x.v===v && x.diagnos;});
    });

    if(a.q2) r.grad = a.q2==="svara"?3:(a.q2==="mattliga"?2:1);
    if(s1.indexOf("ingabesvar")!==-1) r.grad = 1;

    (a.q3||[]).forEach(function(v){
      var k=KRING.filter(function(x){return x.v===v;})[0];
      if(!k) return;
      r.m+=k.m; r.s+=k.s;
      if(k.sig && (k.m>=2||k.s>=2)) r.signals.push({sig:k.sig,vikt:Math.max(k.m,k.s)});
    });
    r.signals.sort(function(x,y){return y.vikt-x.vikt;});

    var menoOk = (a.kon!=="man");

    // Menopause föreslås bara när något av de klimakteriespecifika
    // alternativen kryssats i, alltså ett som väger tyngre mot Menopause än
    // mot Stress. Hjärndimma väger lika åt båda hållen och ska därför kunna
    // dra mot Stress, aldrig ensam mot Menopause.
    var menoSpecifik = (a.q3||[]).some(function(v){
      var k=KRING.filter(function(x){return x.v===v;})[0];
      return k && k.m>k.s;
    });

    // Tröskeln är lägre för den som inte har magbesvär. Har magen det
    // besvärligt ska en svag signal utanför magen inte styra bort från
    // grundprodukten, men saknas magbesvär finns inget att väga mot och
    // då räcker en tydlig signal för att Stress eller Menopause ska passa.
    var trosk = (r.grad===1) ? 2 : 4;

    if(a.kon==="man" && menoSpecifik && r.m>=trosk) r.menoBlocked=true;

    if(menoOk && menoSpecifik && r.m>=trosk && r.m>=r.s) r.produkt="menopause";
    else if(r.s>=trosk)                                  r.produkt="stress";
    else if(a.q3)                                        r.produkt="gutbarrier";

    // Svåra besvär går alltid till grundprodukten. Gut Barrier ger 700 mg
    // ReFerm per kapsel och doseras 1 till 2 gånger om dagen, mot 550 och
    // 600 mg i de andra två. Har magen det svårt ska den inte byta bort
    // postbiotika mot ett näringstillägg.
    if(r.grad===3 && (r.produkt==="stress"||r.produkt==="menopause")){
      r.gradOverride = r.produkt;
      r.produkt = "gutbarrier";
    }

    r.kund=a.q4||null;
    if(r.produkt==="stress"||r.produkt==="menopause"){
      if(a.q4==="tva") r.komplement="storpase";
    }
    return r;
  }

  function kluster(v){
    function h(k){return v.indexOf(k)!==-1;}
    if(h("ingabesvar")) return "ingen";
    if(h("ibd")) return "ibd";
    if(h("divertikulit")) return "divertikulit";
    if(h("bade")||(h("diarre")&&h("forstoppning"))) return "pendlande";
    if(h("uppsvalld")||h("gaser")) return "uppblast";
    if(h("diarre")) return "snabb";
    if(h("forstoppning")) return "trog";
    if(h("smarta")) return "smarta";
    if(h("illamaende")) return "illamaende";
    return "ingen";
  }

  // OBS: meningen här skrivs ut direkt efter att symtomen räknats upp.
  // Den får därför aldrig inledas med symtomets eget namn, då blir det
  // upprepning. Syfta tillbaka med "Det" eller "Den" i stället.
  var SPEGEL={
    ibd:"Ulcerös kolit och Crohns är något annat än en känslig mage, och det vet du bättre än vi. Drygt <strong>en av tio</strong> som gör det här testet anger en diagnos i tarmen.",
    divertikulit:"Det är vanligare bland våra kunder än många tror. <strong>Drygt en av tio</strong> kryssar i den, och de anger dessutom fler besvär än genomsnittet.",
    pendlande:"Att aldrig veta vilken dag det blir är det som är svårast att planera runt. <strong>Fyra av tio</strong> som gör det här testet beskriver exakt samma sak.",
    uppblast:"Det är den vanligaste kombinationen av alla. <strong>Sju av tio</strong> som gör det här testet kryssar i uppsvälldhet, och nästan lika många i gaser.",
    uppblast_upp:"Det är det allra vanligaste besväret hos oss. <strong>Sju av tio</strong> som gör det här testet kryssar i det.",
    uppblast_gas:"Det är det näst vanligaste besväret hos oss. <strong>Sju av tio</strong> som gör det här testet kryssar i det.",
    snabb:"Den tar mer plats i vardagen än den borde. <strong>En av tre</strong> som gör det här testet känner igen sig.",
    trog:"Den syns inte utanpå, men känns hela dagen. <strong>En av fyra</strong> som gör det här testet känner igen sig.",
    smarta:"<strong>Nästan hälften</strong> av dem som gör det här testet kryssar i att de har ont. Är det starka och ihållande smärtor rekommenderar vi alltid att du kontaktar vården, för att utesluta sjukdom.",
    illamaende:"Du är inte ensam! <strong>En av fyra</strong> säger att de har samma besvär.",
    ingen:"Att göra något innan magen krånglar är ovanligt. Bara <strong>tre av hundra</strong> som gör det här testet anger att de inte har besvär."
  };
  var VERDICT={
    diagnos:"Med en diagnos i botten räcker det inte med något som lugnar ytan.",
    svara:"En mage som bestämmer över din vardag ska du inte behöva vänja dig vid.",
    inga:"Bästa läget att göra något är innan magen bestämmer sig för att krångla.",
    pendlande:"Det värsta med en mage som pendlar är att du aldrig vet vilken dag det blir.",
    uppblast:"Du ska inte behöva välja kläder efter hur magen kommer att bete sig.",
    trog:"En mage som inte kommer igång sätter tonen för hela dagen.",
    snabb:"Att alltid veta var närmaste toalett finns är ingen vardag.",
    default:"Det du beskriver är det vanligaste vi möter. Det gör det inte mindre jobbigt."
  };

  /* =====================================================================
     STATE
     ===================================================================== */
  var DEMO = !(window.Shopify && window.Shopify.shop);
  var answers={}, step=0, emailGiven=false, epost="", format="kapsel", addonOn=false;

  /* =====================================================================
     VARIANT-UPPSLAG
     Hämtar rätt variant-ID från Shopify utifrån produktens handle, så att
     ingen behöver klistra in siffror för hand. Resultatet loggas i
     webbläsarens konsol, så det går att se direkt om något är fel.
     ===================================================================== */
  var VARIANT = {};
  function laddaVarianter(){
    var cfg = OB_CONFIG.produkter || {};
    var keys = Object.keys(cfg);
    return Promise.all(keys.map(function(k){
      var c = cfg[k] || {};
      if(c.variantId && !/^0+$/.test(String(c.variantId))){
        VARIANT[k] = String(c.variantId);
        return null;
      }
      if(!c.handle){
        console.error('[OatBiotics] Ingen handle angiven för "'+k+'".');
        return null;
      }
      return fetch("/products/"+encodeURIComponent(c.handle)+".js",{headers:{Accept:"application/json"}})
        .then(function(r){ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
        .then(function(p){
          var vs = p.variants || [];
          var v = vs.filter(function(x){return x.available;})[0] || vs[0];
          if(!v) throw new Error("produkten har inga varianter");
          VARIANT[k] = String(v.id);
          if(vs.length > 1){
            console.warn('[OatBiotics] "'+c.handle+'" har '+vs.length+' varianter. Vald: '+v.title+
                         ' ('+v.id+'). Ange variantId i OB_CONFIG om du vill peka ut en annan.');
          }
        })["catch"](function(e){
          console.error('[OatBiotics] Hittade inte produkten "'+c.handle+'" ('+e.message+
                        '). Kontrollera handle under OB_CONFIG.produkter. Handle är sista delen av produktens webbadress.');
        });
    })).then(function(){
      console.info("[OatBiotics] Variant-ID som används:", JSON.parse(JSON.stringify(VARIANT)));
    });
  }

  // Har man svarat "inga av dessa, jag vill förebygga" är besvärsgraden
  // redan besvarad, så frågan om hur mycket magen tar av vardagen hoppas över.
  function forebygger(){return (answers.q1||[]).indexOf("ingabesvar")!==-1;}
  function qSteps(){
    var s=["q1","kon"];
    if(!forebygger()) s.push("q2");
    return s.concat(["q3","q4"]);
  }
  function visarEpost(){return answers.q4==="ny"||answers.q4==="paus";}
  function rabattkod(){return answers.q4==="paus"?OB_CONFIG.koder.tillbaka:OB_CONFIG.koder.ny;}
  function allSteps(){
    var s=qSteps();
    if(visarEpost()) s=s.concat(["email"]);
    return s.concat(["result"]);
  }

  var root=document.getElementById("ob-quiz");
  if(!root) return;
  root.innerHTML='<div class="ob-card"><div class="ob-head">'+
    '<span class="ob-step" id="ob-stepcount">5 frågor · 45 sekunder</span>'+
    '<div class="ob-dots" id="ob-dots" aria-hidden="true"></div></div>'+
    '<div class="ob-body" id="ob-stage" aria-live="polite"></div></div>'+
    '<div id="ob-demo"></div>';
  if(OB_CONFIG.visaTestscenarier) root.classList.add("ob-wide");

  var stage=document.getElementById("ob-stage");

  function el(tag,cls,txt){var n=document.createElement(tag);if(cls)n.className=cls;if(txt!==undefined)n.textContent=txt;return n;}
  function track(name,data){
    if(!OB_CONFIG.ga4) return;
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push(Object.assign({event:name},data||{}));
  }

  /* =====================================================================
     FRÅGEVYER
     ===================================================================== */
  function renderQuestion(id){
    var q=Q[id];
    stage.innerHTML="";
    stage.appendChild(el("p","ob-kicker",q.kicker));
    stage.appendChild(el("h2","ob-title",q.title));
    if(q.help) stage.appendChild(el("p","ob-help",q.help));

    if(q.chips){
      var items=q.items;
      if(id==="q3" && answers.kon==="man"){
        items=items.filter(function(x){return !(x.m>0 && x.s===0);});
      }
      var box=el("div","ob-chips");
      items.forEach(function(o){
        var b=el("button","ob-chip"+(o.v===q.none?" ob-none":""),o.t);
        b.type="button";
        b.setAttribute("aria-pressed",(answers[id]||[]).indexOf(o.v)!==-1?"true":"false");
        b.addEventListener("click",function(){
          var cur=(answers[id]||[]).slice();
          if(q.none && o.v===q.none){ cur = cur.indexOf(q.none)!==-1 ? [] : [q.none]; }
          else {
            if(q.none) cur=cur.filter(function(x){return x!==q.none;});
            var i=cur.indexOf(o.v);
            if(i===-1) cur.push(o.v); else cur.splice(i,1);
          }
          answers[id]=cur;
          renderQuestion(id);
        });
        box.appendChild(b);
      });
      stage.appendChild(box);

      var nav=el("div","ob-nav");
      if(step>0){var back=el("button","ob-btn ob-ghost","Tillbaka");back.type="button";back.addEventListener("click",prev);nav.appendChild(back);}
      nav.appendChild(el("span","ob-spacer"));
      if(id==="q3"){
        var skip=el("button","ob-quiet","Inget av detta");skip.type="button";
        skip.addEventListener("click",function(){answers[id]=["inget"];next();});
        nav.appendChild(skip);
      }
      var go=el("button","ob-btn ob-primary","Vidare");go.type="button";
      go.disabled=!(answers[id]&&answers[id].length);
      go.addEventListener("click",function(){if(!go.disabled)next();});
      nav.appendChild(go);
      stage.appendChild(nav);
      return;
    }

    var box2=el("div","ob-opts");
    q.opts.forEach(function(o){
      var b=el("button","ob-opt");b.type="button";
      var w=el("span");
      w.appendChild(el("span","ob-lead",o.t));
      if(o.tail) w.appendChild(el("span","ob-tail",o.tail));
      b.appendChild(w);
      var a=el("span","ob-arw","→");a.setAttribute("aria-hidden","true");b.appendChild(a);
      b.addEventListener("click",function(){
        answers[id]=o.v;
        if(id==="kon"&&o.v==="man"&&answers.q3){
          answers.q3=answers.q3.filter(function(v){
            var k=KRING.filter(function(x){return x.v===v;})[0];
            return !(k&&k.m>0&&k.s===0);
          });
        }
        next();
      });
      box2.appendChild(b);
    });
    stage.appendChild(box2);
    if(step>0){
      var nav2=el("div","ob-nav");
      var back2=el("button","ob-btn ob-ghost","Tillbaka");back2.type="button";
      back2.addEventListener("click",prev);nav2.appendChild(back2);
      stage.appendChild(nav2);
    }
  }

  function currentProd(r){
    if(OB_CONFIG.storpaseIlager && format==="pulver" && r.produkt==="gutbarrier") return P.storpase;
    return P[r.produkt];
  }

  function renderEmail(){
    var r=resolve(answers), prod=currentProd(r);
    stage.innerHTML="";
    stage.appendChild(el("p","ob-kicker","Din rekommendation: "+prod.namn));
    if(answers.q4==="paus"){
      stage.appendChild(el("h2","ob-title","Vill du lära dig mer om tarmhälsa, och få 10 procent när du kommer tillbaka?"));
    } else {
      stage.appendChild(el("h2","ob-title","Vill du lära dig mer om tarmhälsa, och samtidigt få 10 procent på ditt första köp?"));
    }
    stage.appendChild(el("p","ob-help","Skriv in din e-post så följer rabattkoden med till kassan. Du kan också hoppa över det här steget."));

    var inp=document.createElement("input");
    inp.type="email"; inp.id="ob-email"; inp.placeholder="din@epost.se";
    inp.setAttribute("aria-label","E-postadress");
    stage.appendChild(inp);

    var nav=el("div","ob-nav");
    var back=el("button","ob-btn ob-ghost","Tillbaka");back.type="button";
    back.addEventListener("click",prev);nav.appendChild(back);
    nav.appendChild(el("span","ob-spacer"));
    var skip=el("button","ob-quiet","Nej tack, visa resultatet");skip.type="button";
    skip.addEventListener("click",function(){emailGiven=false;epost="";next();});
    nav.appendChild(skip);
    var go=el("button","ob-btn ob-primary","Hämta koden");go.type="button";
    go.addEventListener("click",function(){
      if(!/.+@.+\..+/.test(inp.value)){inp.focus();return;}
      emailGiven=true; epost=inp.value.trim();
      track("ob_quiz_email",{produkt:prod.key});
      skickaTillKlaviyo(epost,prod,r);
      next();
    });
    nav.appendChild(go);
    stage.appendChild(nav);
  }

  /* =====================================================================
     KLAVIYO
     Körs i samma stund som kunden lämnar sin e-post, alltså innan hon
     hunnit köpa något. Det är hela poängen: ungefär hälften lämnar e-post,
     och de som inte handlar direkt ska ändå hamna i flödet.

     Två saker händer:
     1. Prenumeration via Klaviyos client-endpoint, med quizsvaren som
        profilegenskaper så att de går att segmentera på.
     2. Ett event, "Quiz genomfört", som kan trigga ett flöde i Klaviyo.
        Kräver ingen nyckel, fungerar om Klaviyos script redan ligger på
        sajten via Shopify-appen.

     Anropet får aldrig stoppa köpet. Går det fel loggas det i konsolen
     och kunden märker ingenting.
     ===================================================================== */
  function klaviyoEgenskaper(prod,r){
    // "Inget av detta" skickas som tom lista, annars skräpar det ner segmenten
    var symtom=(answers.q1||[]).filter(function(v){return v!=="ingabesvar";}).map(function(v){
      var x=SYMTOM.filter(function(y){return y.v===v;})[0];return x?x.t:v;});
    var kring=(answers.q3||[]).filter(function(v){return v!=="inget";}).map(function(v){
      var x=KRING.filter(function(y){return y.v===v;})[0];return x?x.t:v;});
    return {
      "Quiz produkt": prod.namn,
      "Quiz besvarsgrad": r.grad===3?"Svara":(r.grad===2?"Mattliga":"Inga"),
      "Quiz symtom": symtom,
      "Quiz kringsymtom": kring,
      "Quiz kundstatus": answers.q4||"",
      "Quiz kon": answers.kon||"",
      "Quiz poang M": r.m,
      "Quiz poang S": r.s,
      "Quiz rabattkod": rabattkod()
    };
  }

  function skickaTillKlaviyo(adress,prod,r){
    var props=klaviyoEgenskaper(prod,r);

    // 1. Onsite-event, kräver ingen nyckel
    try{
      if(window.klaviyo && typeof window.klaviyo.push==="function"){
        window.klaviyo.push(["identify",Object.assign({$email:adress},props)]);
        window.klaviyo.push(["track","Quiz genomfört",props]);
      }
    }catch(e){ console.warn("[OatBiotics] Klaviyo onsite:",e); }

    // 2. Prenumeration med samtycke
    var k=OB_CONFIG.klaviyo||{};
    if(!k.publicKey || !k.listId){
      console.info("[OatBiotics] Klaviyo: publicKey eller listId saknas, prenumeration hoppades över.");
      return;
    }
    fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+encodeURIComponent(k.publicKey),{
      method:"POST",
      headers:{"Content-Type":"application/json","revision":k.revision||"2024-10-15"},
      body:JSON.stringify({
        data:{
          type:"subscription",
          attributes:{
            profile:{data:{type:"profile",attributes:{email:adress,properties:props}}}
          },
          relationships:{list:{data:{type:"list",id:k.listId}}}
        }
      })
    }).then(function(res){
      if(res.ok) console.info("[OatBiotics] Klaviyo: prenumeration skickad för "+adress);
      else res.text().then(function(t){
        console.error("[OatBiotics] Klaviyo svarade "+res.status+": "+t+
          " Kontrollera publicKey, listId och att revision-datumet stämmer med Klaviyos aktuella API.");
      });
    })["catch"](function(e){
      console.error("[OatBiotics] Klaviyo gick inte att nå:",e);
    });
  }

  function listSv(a){
    if(a.length===1) return a[0];
    if(a.length===2) return a[0]+" och "+a[1];
    return a.slice(0,-1).join(", ")+" och "+a[a.length-1];
  }
  function cap(s){return s.charAt(0).toUpperCase()+s.slice(1);}
  function sec(h,paras){
    var s=el("div","ob-sec");
    if(h) s.appendChild(el("h4",null,h));
    paras.forEach(function(x){var p=el("p");p.innerHTML=x;s.appendChild(p);});
    return s;
  }
  // Tidigare stod här hur många andra som anger färre besvär. Det blev en
  // rangordning som satte kunden sist, vilket är fel signal till någon som
  // redan känner sig som ett hopplöst fall. Nu är raden enbart igenkänning.
  function antalRad(n){
    if(n>=5) return " Att ha flera besvär samtidigt är vanligt hos våra kunder, du är långt ifrån ensam.";
    return "";
  }

  /* =====================================================================
     RESULTAT
     ===================================================================== */
  function renderResult(){
    var r=resolve(answers), prod=currentProd(r);
    stage.innerHTML="";

    var sv=answers.q1||[];
    var s1=sv.map(function(v){return SYMTOM.filter(function(x){return x.v===v;})[0];}).filter(Boolean);
    s1.sort(function(a,b){return b.n-a.n;});
    var kl=kluster(sv), klSpegel=kl;
    if(kl==="uppblast"){
      var hu=sv.indexOf("uppsvalld")!==-1, hg=sv.indexOf("gaser")!==-1;
      if(hu&&!hg) klSpegel="uppblast_upp";
      else if(hg&&!hu) klSpegel="uppblast_gas";
    }

    var verdict;
    if(kl==="ibd"||kl==="divertikulit") verdict=VERDICT.diagnos;
    else if(r.grad===3) verdict=VERDICT.svara;
    else if(r.grad===1) verdict=VERDICT.inga;
    else verdict=VERDICT[kl]||VERDICT.default;
    stage.appendChild(el("h2","ob-verdict",verdict));

    var mir=el("p","ob-mirror");
    var namngivna=s1.filter(function(x){return x.kort;});
    if(namngivna.length){
      var top=namngivna.slice(0,3).map(function(x){return x.kort;});
      mir.innerHTML=cap(listSv(top))+". "+SPEGEL[klSpegel]+antalRad(namngivna.length);
    } else { mir.innerHTML=SPEGEL.ingen; }
    stage.appendChild(mir);

    var pc=el("div","ob-prod");
    pc.appendChild(el("p","ob-eyebrow","Vi föreslår"));
    pc.appendChild(el("h3",null,prod.namn));
    pc.appendChild(el("p","ob-meta",prod.pack+" · "+prod.pris+" kr"+(prod.dag?" · "+prod.dag:"")));
    pc.appendChild(el("p","ob-what",prod.what));
    stage.appendChild(pc);

    var vs=el("div","ob-sec");
    vs.appendChild(el("h4",null,"Så räknade vi"));
    if(r.signals.length && r.produkt!=="gutbarrier"){
      vs.appendChild(el("p",null,"Du kryssade i:"));
      var ul=el("ul","ob-signals");
      r.signals.slice(0,3).forEach(function(x){ul.appendChild(el("li",null,cap(x.sig)));});
      vs.appendChild(ul);
      var why=el("p");
      why.innerHTML = r.produkt==="menopause"
        ? "Baserat på dina val låter det som att du påverkas av en förändring i hormoner kopplat till förklimakteriet eller klimakteriet. Därför föreslår vi OatBiotics® Menopause som innehåller Vitamin B6 som bidrar till att reglera hormonaktiviteten samt rödklöverextrakt som traditionellt används vid klimakteriebesvär."
        : "Hjärnan och magen är nära sammankopplade och det låter som om du påverkas av inre eller yttre faktorer. Därför föreslår vi OatBiotics® Stress som utöver postbiotika innehåller zink, pantotensyra, B6 och B12.";
      vs.appendChild(why);
    } else if(r.gradOverride){
      var g1=el("p");
      g1.innerHTML="Eftersom du har angett att du har stora magbesvär, är det där vi börjar. Allt hänger ihop, och när du börjat få kontroll över magen kan resten av dina besvär också minska.";
      vs.appendChild(g1);
      var g2=el("p");
      g2.innerHTML="Gut Barrier ger <strong>700 mg ReFerm® per kapsel</strong> och kan tas två gånger om dagen. Den är en bra start för att låta magen vänja sig. Som nästa steg kan du behöva öka mängden aktiv ingrediens och därmed gå över till att ta pulver (240 g-påsen).";
      vs.appendChild(g2);
    } else if(r.menoBlocked){
      var m1=el("p");m1.innerHTML="Du kryssade i symtom som annars pekar mot en hormonell omställning. Menopause är utvecklad för klimakteriet och innehåller rödklöver, så den föreslår vi inte här.";
      vs.appendChild(m1);
      var m2=el("p");m2.innerHTML="Sömn, energi och humör hänger ihop med magen oavsett kön. Vår originalprodukt Gut Barrier är rätt väg in.";
      vs.appendChild(m2);
    } else {
      var p1=el("p");
      p1.innerHTML = r.signals.length
        ? "Du kryssade i "+r.signals[0].sig+", men inget tydligt mönster utöver det. Därför rekommenderar vi att du startar med vår originalprodukt, där du får den största mängden aktiv ingrediens i form av postbiotika."
        : "Eftersom du har angett att dina besvär endast är kopplade till magen rekommenderar vi att du startar med vår originalprodukt, där du får den största mängden aktiv ingrediens i form av postbiotika.";
      vs.appendChild(p1);
      var p2=el("p");p2.innerHTML="OatBiotics® Gut Barrier innehåller 100% av ReFerm® per kapsel och är utvecklad för magrelaterade besvär.";
      vs.appendChild(p2);
    }
    stage.appendChild(vs);

    if(r.diagnos){
      stage.appendChild(sec(null,["Du angav en diagnostiserad tarmsjukdom. Produkterna är kosttillskott och ersätter ingen behandling. Står du på medicin är det värt att nämna för din läkare att du börjar med ett postbiotikum."]));
    }

    // Postbiotika, den viktigaste differentieringen. Visas för alla.
    stage.appendChild(sec("Varför postbiotika och inte probiotika",[
      "Har du provat olika probiotika men inte upplevt den effekt du önskat? <strong>OatBiotics® är inte fler bakterier.</strong>",
      "Postbiotika fungerar annorlunda. I stället för att tillföra bakterier som ska göra jobbet tillför du den färdiga näringen som bakterierna skulle ha producerat. Den näringen påverkar miljön i tarmen så att den tarmflora du redan har trivs och samarbetar med kroppen.",
      "OatBiotics® innehåller ReFerm®, en forskningsbaserad postbiotika gjord på fermenterad svensk havre."
    ]));

    // Förväntanshantering. Tidslinjen beskriver postbiotikan, som är
    // densamma i alla tre produkterna.
    var tid=[];
    if(prod===P.gutbarrier || prod===P.storpase){
      tid.push("Det ärliga svaret är att vi inte vet om det kommer att hjälpa just dig. Mag- och tarmhälsa är komplext och alla har unika tarmfloror och därmed förutsättningar. Ingen produkt fungerar för alla, men eftersom OatBiotics® fungerar annorlunda än probiotika brukar de allra flesta bli hjälpta. Så här kan det se ut:");
      tid.push("<strong>Vecka 1 till 2.</strong> Magen vänjer sig. Vissa märker stor skillnad, andra mindre och vissa inget alls.");
      tid.push("<strong>Vecka 2 till 4.</strong> Här börjar många av våra kunder märka skillnad.");
      tid.push("<strong>Efter 1 till 2 månader.</strong> Den som inte märker skillnad här rekommenderas att överväga en större dos med pulver.");
    } else {
      tid.push("Det ärliga svaret är att vi inte vet om just du kommer att märka skillnad. Ingen produkt fungerar för alla, men eftersom OatBiotics® fungerar annorlunda än probiotika brukar de allra flesta bli hjälpta.");
    }
    stage.appendChild(sec("Kommer det fungera för mig?",tid));

    var facts=el("div","ob-facts");
    // Fyra rutor som svarar på var sin fråga: är det seriöst, är jag ensam,
    // tål jag det, var kommer det ifrån. Fyra stycken går jämnt ut i två
    // rader på mobil, tre lämnade en tom ruta. Samma för alla produkter.
    [["20+ år","forskning bakom ReFerm®"],
     ["14 000+","kunder sedan starten"],
     ["Vegansk","laktosfri och FODMAP-vänlig"],
     ["🇸🇪","tillverkad i Sverige"]].forEach(function(f){
      var d=el("div","ob-fact");d.appendChild(el("b",null,f[0]));d.appendChild(el("span",null,f[1]));facts.appendChild(d);
    });
    stage.appendChild(facts);

    var dos=[];
    if(prod===P.storpase){
      dos.push("<strong>Börja med 1 msk om dagen</strong> och hitta sedan den mängd som passar dig. ReFerm® är ett livsmedel, så du kan varken under- eller överdosera.");
      dos.push("Strö över gröt eller yoghurt, eller blanda i en smoothie. Den passar hela familjen, även de små som behöver extra näring.");
    } else {
      dos.push("<strong>"+prod.dos+".</strong> En förpackning räcker "+prod.rack+".");
      if(r.produkt==="gutbarrier") dos.push("Börja på en kapsel om dagen. Känns det bra efter en vecka går du upp till två.");
    }
    if(r.grad===3) dos.push("Börja ändå försiktigt. Har magen varit i obalans länge behöver den få vänja sig innan du ökar.");
    stage.appendChild(sec("Så tar du den",dos));

    // Formatväxeln finns bara när storpåsen går att köpa. Pulver är
    // storpåsen, så utan lager finns inget att växla till.
    if(OB_CONFIG.storpaseIlager){
      var fw=el("div");
      var fmt=el("div","ob-fmt");fmt.setAttribute("role","group");fmt.setAttribute("aria-label","Format");
      [["kapsel","Kapsel"],["pulver","Pulver"]].forEach(function(f){
        var b=el("button",null,f[1]);b.type="button";
        b.setAttribute("aria-pressed",format===f[0]?"true":"false");
        b.addEventListener("click",function(){format=f[0];renderResult();});
        fmt.appendChild(b);
      });
      fw.appendChild(fmt);
      if(format==="pulver" && r.produkt!=="gutbarrier"){
        fw.appendChild(el("p","ob-fmtnote",prod.namn+" finns bara som kapsel. Vill du ha pulver är storpåsen vägen, och den ligger som tillval nedan."));
      }
      stage.appendChild(fw);
    }

    stage.appendChild(buildCart(r,prod));

    track("ob_quiz_result",{produkt:prod.key,grad:r.grad,m:r.m,s:r.s,kluster:kl,kund:r.kund||"",kon:r.kon||""});
  }

  /* =====================================================================
     VARUKORG OCH KÖP
     ===================================================================== */
  function buildCart(r,prod){
    var forced=(format==="pulver" && r.produkt!=="gutbarrier");
    var offerAddon=OB_CONFIG.storpaseIlager && (r.komplement==="storpase"||forced);

    var cart=el("div","ob-cart");
    function row(pr,note,cls){
      var x=el("div","ob-row"+(cls?" "+cls:""));
      var left=el("div");
      left.appendChild(el("span","ob-nm",pr.namn));
      left.appendChild(el("span","ob-sz",note||pr.pack));
      x.appendChild(left);x.appendChild(el("span","ob-pr",pr.pris+" kr"));
      return x;
    }
    cart.appendChild(row(prod));

    var addonBox=null,addonLabel=null;
    if(offerAddon){
      var note;
      if(forced) note="Samma fermenterade havre i lös form, för dig som hellre blandar än sväljer. Börja med 1 msk om dagen.";
      // OBS: en matsked pulver innehåller betydligt mer ReFerm än två kapslar.
      // Texten får därför inte påstå att pulvret håller kunden kvar på samma
      // nivå som tidigare, den ska säga att det är mer.
      else if(answers.q4==="tva") note="Du tar två kapslar om dagen idag. En matsked pulver ger mer ReFerm® än så, och du doserar själv precis den mängd du vill ha.";
      else note="Lägg på 1 msk om dagen utöver kapseln. ReFerm® är ett livsmedel, du kan varken under- eller överdosera.";

      addonLabel=document.createElement("label");
      addonLabel.className="ob-addon"+(addonOn?" on":"");
      addonLabel.setAttribute("for","ob-addon-storpase");
      addonBox=document.createElement("input");
      addonBox.type="checkbox";addonBox.id="ob-addon-storpase";addonBox.checked=addonOn;
      addonLabel.appendChild(addonBox);
      var bod=el("div","ob-b");
      bod.appendChild(el("span","ob-eyeb","Lägg till om du vill"));
      bod.appendChild(el("span","ob-nm",P.storpase.namn));
      bod.appendChild(el("span","ob-sz",note));
      addonLabel.appendChild(bod);
      addonLabel.appendChild(el("span","ob-pr","+ "+P.storpase.pris+" kr"));
      cart.appendChild(addonLabel);
    }

    var sumBox=el("div");
    cart.appendChild(sumBox);

    var cta=el("div","ob-cta");
    var buy=el("button","ob-btn ob-primary","Till kassan");buy.type="button";
    var add=el("button","ob-btn ob-second","Lägg i varukorgen");add.type="button";
    cta.appendChild(buy);cta.appendChild(add);
    var fine=el("p","ob-fine");
    if(prod===P.gutbarrier){
      // Relativ länk, så den följer med domänen testet ligger på.
      // Öppnas i ny flik så att kunden inte tappar sitt resultat.
      fine.innerHTML='<a href="/pages/garanti" target="_blank" rel="noopener noreferrer" style="color:inherit">Nöjd-mage-garanti</a> · Skickas från Sverige';
    } else {
      fine.textContent="Betala med Klarna, Swish eller kort · Skickas från Sverige";
    }
    cta.appendChild(fine);
    var err=el("p","ob-err");err.hidden=true;cta.appendChild(err);
    cart.appendChild(cta);

    function items(){
      var list=[{key:prod.key,id:VARIANT[prod.key],quantity:1}];
      if(offerAddon&&addonOn) list.push({key:"storpase",id:VARIANT.storpase,quantity:1});
      return list;
    }
    function saknade(){
      return items().filter(function(i){return !i.id;}).map(function(i){return i.key;});
    }
    function paintSum(){
      var on=offerAddon&&addonOn;
      var sub=prod.pris+(on?P.storpase.pris:0);
      var disc=emailGiven?Math.round(sub*0.1):0;
      sumBox.innerHTML="";
      if(emailGiven){
        var d=el("div","ob-row");
        var l=el("div");
        l.appendChild(el("span","ob-nm","Rabattkod "+rabattkod()));
        l.appendChild(el("span","ob-sz",answers.q4==="paus"?"10 procent när du kommer tillbaka":"10 procent på första köpet"));
        d.appendChild(l);d.appendChild(el("span","ob-pr","−"+disc+" kr"));
        sumBox.appendChild(d);
      }
      var tot=el("div","ob-row ob-total");
      tot.appendChild(el("span","ob-nm","Att betala"));
      tot.appendChild(el("span","ob-pr",(sub-disc)+" kr"));
      sumBox.appendChild(tot);
      buy.textContent = on ? "Till kassan med båda" : "Till kassan";
    }
    paintSum();

    if(addonBox){
      addonBox.addEventListener("change",function(){
        addonOn=addonBox.checked;
        addonLabel.className="ob-addon"+(addonOn?" on":"");
        paintSum();
        track("ob_quiz_addon",{vald:addonOn,produkt:prod.key});
      });
    }

    function visaFel(txt){err.hidden=false;err.textContent=txt;}
    function felaktigKonfig(){
      var s=saknade();
      if(!s.length) return false;
      var h=s.map(function(k){return (OB_CONFIG.produkter[k]||{}).handle||k;}).join(", ");
      visaFel("Produkten kunde inte hittas i butiken: "+h+". Kontrollera handle i inställningarna.");
      console.error('[OatBiotics] Saknar variant-ID för: '+s.join(", ")+
                    '. Kontrollera OB_CONFIG.produkter mot produkternas webbadresser.');
      return true;
    }

    function addToCart(){
      return fetch("/cart/add.js",{
        method:"POST",
        headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({items:items().map(function(i){return {id:i.id,quantity:i.quantity};})})
      }).then(function(res){
        if(!res.ok) return res.json().then(function(j){throw new Error(j.description||"Kunde inte lägga i varukorgen");});
        return res.json();
      }).then(function(data){
        if(!OB_CONFIG.sparaCartAttributes) return data;
        return fetch("/cart/update.js",{
          method:"POST",
          headers:{"Content-Type":"application/json"},
          body:JSON.stringify({attributes:{
            "Quiz-produkt":prod.namn,
            "Quiz-epost":epost||"",
            "Quiz-besvar":JSON.stringify(answers),
            "Quiz-poang":"M"+resolve(answers).m+"/S"+resolve(answers).s
          }})
        }).then(function(){return data;});
      });
    }

    buy.addEventListener("click",function(){
      track("ob_checkout",{produkt:prod.key,tillval:addonOn});
      if(DEMO){ buy.textContent="Demoläge: går till kassan på referm.se"; return; }
      if(felaktigKonfig()) return;
      buy.disabled=true; buy.textContent="Ett ögonblick...";
      addToCart().then(function(){
        var kod = emailGiven ? rabattkod() : "";
        window.location.href = kod ? "/discount/"+encodeURIComponent(kod)+"?redirect=/checkout" : "/checkout";
      })["catch"](function(e){
        buy.disabled=false; buy.textContent="Till kassan";
        visaFel(e.message||"Något gick fel. Försök igen.");
      });
    });

    add.addEventListener("click",function(){
      track("ob_add_to_cart",{produkt:prod.key,tillval:addonOn});
      if(DEMO){ add.textContent="Demoläge: lagd i varukorgen"; return; }
      if(felaktigKonfig()) return;
      add.disabled=true; add.textContent="Lägger till...";
      addToCart().then(function(){
        add.textContent="Tillagd i varukorgen";
        document.dispatchEvent(new CustomEvent("ob:cart-updated"));
        setTimeout(function(){add.disabled=false;add.textContent="Lägg i varukorgen";},2500);
      })["catch"](function(e){
        add.disabled=false; add.textContent="Lägg i varukorgen";
        visaFel(e.message||"Något gick fel. Försök igen.");
      });
    });

    return cart;
  }

  /* =====================================================================
     NAVIGATION
     ===================================================================== */
  function render(){
    var steps=allSteps();
    if(step>=steps.length) step=steps.length-1;
    if(step<0) step=0;
    var id=steps[step];
    var qs=qSteps(), qi=qs.indexOf(id);

    var counter=document.getElementById("ob-stepcount");
    if(qi===0 && !answers[id]) counter.textContent=qs.length+" frågor · 45 sekunder";
    else if(qi!==-1) counter.textContent="Fråga "+(qi+1)+" av "+qs.length;
    else counter.textContent = id==="result" ? "Ditt resultat" : "Nästan klart";

    var dots=document.getElementById("ob-dots");dots.innerHTML="";
    for(var i=0;i<qs.length;i++) dots.appendChild(el("i",(qi===-1||i<=qi)?"on":""));

    if(id==="email") renderEmail();
    else if(id==="result") renderResult();
    else { renderQuestion(id); if(qi!==-1) track("ob_quiz_question",{fraga:id,nr:qi+1}); }
  }
  function next(){step++;render();}
  function prev(){step--;render();}
  function reset(){answers={};emailGiven=false;epost="";format="kapsel";addonOn=false;step=0;render();}

  /* =====================================================================
     TESTSCENARIER, visas bara utanför Shopify
     ===================================================================== */
  var SCEN=[
    {n:"Uppsvälld och gaser, inget mer",tag:"Gut Barrier",a:{q1:["uppsvalld","gaser"],kon:"kvinna",q2:"mattliga",q3:["inget"],q4:"ny"}},
    {n:"Uppsvälld + värmevallningar",tag:"Menopause",a:{q1:["uppsvalld","gaser","smarta"],kon:"kvinna",q2:"mattliga",q3:["vallningar","somn"],q4:"ny"}},
    {n:"Pendlande mage + kan inte varva ner",tag:"Stress",a:{q1:["bade","smarta"],kon:"kvinna",q2:"mattliga",q3:["varvaner","spand"],q4:"ny"}},
    {n:"Vallningar OCH kan inte varva ner",tag:"Oavgjort → Menopause",a:{q1:["uppsvalld"],kon:"kvinna",q2:"mattliga",q3:["vallningar","varvaner"],q4:"ny"}},
    {n:"Man, stressad",tag:"Stress",a:{q1:["bade","gaser"],kon:"man",q2:"mattliga",q3:["varvaner","spand"],q4:"ny"}},
    {n:"Man, bara sämre sömn",tag:"Gut Barrier",a:{q1:["uppsvalld","gaser"],kon:"man",q2:"mattliga",q3:["somn"],q4:"ny"}},
    {n:"Bara sämre sömn, svag signal",tag:"Gut Barrier",a:{q1:["forstoppning","gaser"],kon:"ejsvar",q2:"mattliga",q3:["somn"],q4:"ny"}},
    {n:"Svåra besvär + mens upphört",tag:"Svåra → Gut Barrier",a:{q1:["uppsvalld","smarta","diarre"],kon:"kvinna",q2:"svara",q3:["mens","vallningar","torrhet"],q4:"ny"}},
    {n:"Befintlig kund, 2 kapslar",tag:"Stress + tillval",a:{q1:["uppsvalld","bade"],kon:"kvinna",q2:"mattliga",q3:["varvaner","irriterad"],q4:"tva"}},
    {n:"Befintlig kund, 1 kapsel",tag:"Utan rabattsteg",a:{q1:["uppsvalld","gaser"],kon:"kvinna",q2:"mattliga",q3:["inget"],q4:"en"}},
    {n:"Gjort uppehåll",tag:"Koden TILLBAKA",a:{q1:["bade","smarta"],kon:"kvinna",q2:"mattliga",q3:["inget"],q4:"paus"}},
    {n:"Svåra besvär + diarré",tag:"Diagnosgrupp borttagen",a:{q1:["diarre","smarta"],kon:"kvinna",q2:"svara",q3:["inget"],q4:"ny"}},
    {n:"Svåra besvär + vallningar",tag:"Svåra → Gut Barrier",a:{q1:["uppsvalld","smarta"],kon:"kvinna",q2:"svara",q3:["vallningar","mens"],q4:"ny"}},
    {n:"Hjärndimma + klimakteriebesvär",tag:"Menopause",a:{q1:["uppsvalld","gaser"],kon:"kvinna",q2:"mattliga",q3:["hjarndimma","klimakterie"],q4:"ny"}},
    {n:"Hjärndimma + varva ner",tag:"Stress",a:{q1:["bade"],kon:"kvinna",q2:"mattliga",q3:["hjarndimma","varvaner"],q4:"ny"}},
    {n:"Vill bara förebygga",tag:"Gut Barrier",a:{q1:["ingabesvar"],kon:"kvinna",q2:"inga",q3:["inget"],q4:"ny"}},
    {n:"Bara förstoppning",tag:"Gut Barrier",a:{q1:["forstoppning"],kon:"kvinna",q2:"mattliga",q3:["inget"],q4:"en"}}
  ];

  if(OB_CONFIG.visaTestscenarier){
    var d=document.getElementById("ob-demo");
    d.className="ob-demo";
    d.innerHTML='<h5>Testscenarier</h5><div class="ob-in"></div>';
    var inn=d.querySelector(".ob-in");
    SCEN.forEach(function(s){
      var b=document.createElement("button");b.type="button";
      b.appendChild(el("span",null,s.n));
      b.appendChild(el("span","ob-tag",s.tag));
      b.addEventListener("click",function(){
        answers=JSON.parse(JSON.stringify(s.a));
        emailGiven=false;epost="";format="kapsel";addonOn=false;
        step=allSteps().length-1;
        render();
        root.scrollIntoView({behavior:"smooth",block:"start"});
      });
      inn.appendChild(b);
    });
    var rb=document.createElement("button");rb.type="button";
    rb.appendChild(el("span",null,"Börja om från fråga 1"));
    rb.appendChild(el("span","ob-tag","Nollställ"));
    rb.addEventListener("click",function(){reset();root.scrollIntoView({behavior:"smooth",block:"start"});});
    inn.appendChild(rb);
  }

  if(!DEMO) laddaVarianter();
  track("ob_quiz_start",{});
  render();
})();